import { Button } from "react-bootstrap";
import { useState, useEffect } from "react";

const Pagination = ({
  nPages,
  currentPage,
  setCurrentPage,
  setQuizStatus,
  showPreviousButton = true,
  showNextButton = true,
  showFinishButton,
}) => {
  const nextPage = () => {
    if (currentPage < nPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div
      className={`d-flex justify-content-${
        currentPage > 1 && showPreviousButton && showNextButton
          ? "between"
          : "end"
      }`}
    >
      {showPreviousButton && currentPage > 1 && (
        <Button variant="secondary" onClick={prevPage}>
          <i className="fe fe-arrow-left"></i> Previous
        </Button>
      )}

      {currentPage === nPages || showFinishButton ? (
        <Button variant="primary" onClick={() => setQuizStatus("finish")}>
          Finish
        </Button>
      ) : (
        showNextButton && (
          <Button variant="primary" onClick={nextPage}>
            Next <i className="fe fe-arrow-right"></i>
          </Button>
        )
      )}
    </div>
  );
};

export default Pagination;
